import { render, staticRenderFns } from "./SlackCallbackPage.vue?vue&type=template&id=05f9081d"
import script from "./SlackCallbackPage.vue?vue&type=script&lang=ts"
export * from "./SlackCallbackPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports